import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subject } from '@microsoft/signalr';
import { BehaviorSubject, Observable } from 'rxjs';
import { LinkInformation } from '../../interfaces/linkinformation.interface';
import { LinkInformationService } from '../../services/link-information.service';
import { bind, bindGridToolbarButton, showErrorSwal } from '@asamco/utils';
import Swal from 'sweetalert2';
import { DxoEditingModule, DxoPopupModule, DxoFormModule, DxiItemModule, DxoSortingModule, DxoSelectionModule, DxoRowDraggingModule, DxoScrollingModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shell-admin-marketplace-management',
    templateUrl: './admin-marketplace-management.component.html',
    styleUrls: ['./admin-marketplace-management.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, DxDataGridModule, DxoEditingModule, DxoPopupModule, DxoFormModule, DxiItemModule, DxoSortingModule, DxoSelectionModule, DxoRowDraggingModule, DxoScrollingModule, DxiColumnModule, AsyncPipe]
})
export class AdminMarketplaceManagementComponent implements OnInit {


  title: string = "Admin manage marketplace"
  public showSubject = new BehaviorSubject<boolean>(false);

  public selectedTab: number = 0;

  public linkInformation$: Observable<LinkInformation[]>;
  public linkInformation: LinkInformation[];


  listOfTabs: any[] = [
		{
			ID: 1,
			TabName: 'Configure link information sorting'
		},
		{
			ID: 2,
			TabName: 'Settings grouping configuration'
		}
	]

  submitButtonOptions = {
    text: "Submit the Form",
    useSubmitBehavior: true
}




  constructor(private cdr: ChangeDetectorRef, private linkInformationService: LinkInformationService) { }


  ngOnInit(): void {
  }

  setupModal() {
    this.linkInformationService.getAll().subscribe(e => {
      this.linkInformation = e.sort(item => item.sortingIndex);
      this.cdr.detectChanges();
    })

    this.showSubject.next(true);
  }

  @bind
  onAdd(e) {
    // var objIndex = this.linkSettings.findIndex(item => item.id == e.itemData.id);
    // this.linkSettings[objIndex].groupName = e.toData;
    e.itemData.groupName = e.toData;
    this.linkInformation = [...this.linkInformation]
    this.cdr.markForCheck();
  }

  @bind
  onReorder(e) {
    // Get visible rows and sort them by `sortingIndex`
    let visibleRows = e.component.getVisibleRows().sort((a, b) => a.data.sortingIndex - b.data.sortingIndex);

    // Sort `linkInformation` by `sortingIndex`
    this.linkInformation.sort((a, b) => a.sortingIndex - b.sortingIndex);

    // Find the target indices for moving the item
    const toIndex = this.linkInformation.indexOf(visibleRows[e.toIndex].data);
    const fromIndex = this.linkInformation.indexOf(e.itemData);

    // Remove and insert the item at the new position
    const [movedItem] = this.linkInformation.splice(fromIndex, 1);
    this.linkInformation.splice(toIndex, 0, movedItem);

    // Reassign `sortingIndex` to ensure all items have unique, sequential indices
    this.linkInformation.forEach((item, index) => {
      item.sortingIndex = index + 1;
    });

    // Trigger Angular's change detection
    this.cdr.markForCheck();
  }

  updateSettingTemplateField(e) {
    let linkInformation = e.data;
    this.linkInformationService.updateSingle(linkInformation).subscribe(e => {
      Swal.fire({title: "Successfully updated entity", icon: 'success'})
    }, error => {
      showErrorSwal(error)
    })
  }

  saveSortingIndex() {
    this.linkInformationService.updateMultipleSortingIndex(this.linkInformation).subscribe(e => {
      Swal.fire({icon: 'success', text: "Successfully updated settings"})
    }, error => {
      showErrorSwal(error);
    })
  }

  cancel() {
    this.showSubject.next(false)
  }

}
